import { FC, useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Icon,
  MenuItem,
  useDisclosure,
} from '@chakra-ui/react';
import { FaFileDownload } from 'react-icons/fa';

import { usePiiReport } from '../../context/pii-report-context';

export const DownloadPiiReportMenuItem: FC = () => {
  const cancelRef = useRef(null);
  const { download } = usePiiReport();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleDownload = async () => {
    download();
    onClose();
  };

  return (
    <>
      <MenuItem onClick={onOpen} data-testid="download-button">
        <Icon as={FaFileDownload} mr={2} fontSize="16" color="gray.700" />
        Download PII Report
      </MenuItem>
      <AlertDialog
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        closeOnOverlayClick={false}
        leastDestructiveRef={cancelRef}
        data-testid="confirmation-dialog"
      >
        <AlertDialogOverlay />
        <AlertDialogContent data-testid="confirmation-dialog-content">
          <AlertDialogHeader>Download PII Report</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            This report contains details regarding files containing PII. It may
            take some time to generate the report.
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ml={3}
              colorScheme="blue"
              onClick={handleDownload}
              data-testid="confirm-download-button"
            >
              Download
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
